import {
    Input,
    TemplateRef,
    ViewChild
} from "@angular/core";
import { Common } from "./common";

export abstract class Item extends Common {
    @ViewChild('contentTemplate') contentTemplate: TemplateRef<any>;
}



// WEBPACK FOOTER //
// ./client-src/app/core/baseObjects/item.ts